export default "__VITE_ASSET__A$bh8p35__"